(function () {
  var registryRequests = new Map();
  function registry(url) {
    if (!registryRequests.has(url)) registryRequests.set(url, fetch(url).then(function (r) { if (!r.ok) throw new Error('Preview configuration unavailable'); return r.json(); }));
    return registryRequests.get(url);
  }
  function init() {
    document.querySelectorAll('[data-template-preview]').forEach(function (preview) {
      if (preview.dataset.initialized) return;
      preview.dataset.initialized = 'true';
      var section = preview.closest('[data-section-type="product"]');
      var button = preview.querySelector('[data-template-generate]');
      var status = preview.querySelector('[data-template-status]');
      var cards = preview.querySelector('[data-template-cards]');
      var config = null, generated = false, everGenerated = false;
      function place() {
        var form = section.querySelector('#ProductFormWrapper') || section.querySelector('.acerill-product-form');
        if (form && form.nextElementSibling !== preview) form.insertAdjacentElement('afterend', preview);
      }
      function sync() {
        button.hidden = !config || generated;
        button.disabled = generated;
        preview.dataset.stale = String(!generated && everGenerated);
        if (config) status.textContent = generated ? preview.dataset.statusReady : preview.dataset.statusPending;
      }
      function edited(event) {
        if (event.target.closest('#ProductFormWrapper, .acerill-product-form')) { generated = false; sync(); }
      }
      section.addEventListener('input', edited);
      section.addEventListener('change', edited);
      var cart = section.querySelector('[name="add"]');
      if (cart) {
        cart.disabled = false;
        new MutationObserver(function () { if (cart.disabled) cart.disabled = false; }).observe(cart, {attributes:true,attributeFilter:['disabled']});
      }
      function read(names) {
        return names.map(function (name) {
          var field = Array.from(section.querySelectorAll('[name]')).find(function (input) { return input.name === 'properties[' + name + ']'; });
          return field ? field.value.trim() : '';
        }).filter(Boolean).join(', ');
      }
      function safeImage(url) {
        try { var parsed = new URL(url, location.href); return parsed.protocol === 'https:' && (parsed.origin === location.origin || parsed.hostname === 'cdn.shopify.com'); } catch (_) { return false; }
      }
      function render() {
        var ns = 'http://www.w3.org/2000/svg';
        cards.replaceChildren();
        config.sides.forEach(function (side) {
          var svg = document.createElementNS(ns, 'svg');
          svg.setAttribute('viewBox', '0 0 ' + side.width + ' ' + side.height);
          svg.setAttribute('role', 'img'); svg.setAttribute('aria-label', side.label);
          var image = document.createElementNS(ns, 'image');
          image.setAttribute('href', side.background); image.setAttribute('width', side.width); image.setAttribute('height', side.height); svg.appendChild(image);
          (side.fields || []).forEach(function (field) {
            var text = document.createElementNS(ns, 'text');
            text.setAttribute('x', field.x); text.setAttribute('y', field.y); text.setAttribute('fill', field.fill || '#222');
            text.setAttribute('font-family', field.fontFamily || 'Arial, sans-serif'); text.setAttribute('font-size', field.fontSize);
            text.textContent = read(field.names) || field.default || '';
            svg.appendChild(text);
          });
          cards.appendChild(svg);
          Array.from(svg.querySelectorAll('text')).forEach(function (text, index) {
            var field = side.fields[index]; var length = text.getComputedTextLength();
            if (field.maxWidth && length > field.maxWidth) text.setAttribute('font-size', field.fontSize * field.maxWidth / length);
          });
        });
      }
      button.addEventListener('click', function () {
        if (!config) return;
        var form = section.querySelector('#ProductFormWrapper') || section.querySelector('.acerill-product-form');
        var fields = form ? Array.from(form.querySelectorAll('input,textarea,select')) : [];
        if (!fields.length) return;
        var invalid = fields.find(function (field) { return !field.checkValidity(); });
        if (invalid) { invalid.reportValidity(); return; }
        render(); generated = true; everGenerated = true; sync();
      });
      place(); new MutationObserver(place).observe(section, {childList:true,subtree:true});
      registry(preview.dataset.registryUrl).then(function (data) {
        var candidate = data.products[preview.dataset.productHandle];
        if (!candidate || candidate.status !== 'active' || candidate.renderer !== 'svg' || !Array.isArray(candidate.sides) || !candidate.sides.length) return;
        if (!candidate.sides.every(function (side) { return side.width > 0 && side.height > 0 && side.label && safeImage(side.background) && (!side.fields || side.fields.every(function (f) { return Array.isArray(f.names) && Number.isFinite(f.x) && Number.isFinite(f.y) && f.fontSize > 0; })); })) return;
        config = candidate; sync();
      }).catch(function () { button.hidden = true; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
